import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import './WrappedFormIncrementalStepper.scss';

function WrappedIncrementalFormStepper(props) {
  const { 
    input, 
    formatValue, 
    parseValue, 
    disabled, 
    ...rest 
  } = props;

  const { onChange, value } = input || {};

  // Extract min, max, and step from rest to use in our math, defaulting to standard stepper logic
  const step = rest.step !== undefined ? Number(rest.step) : 1;
  const min = rest.min !== undefined ? Number(rest.min) : -Infinity;
  const max = rest.max !== undefined ? Number(rest.max) : Infinity;

  // Omit the props we don't want spreading to the DOM wrapper
  const cleanProps = _.omit(rest, ['input', 'formatValue', 'parseValue', 'meta', 'min', 'max', 'step']);

  // Ensure our current value is a clean number for math operations
  const numericValue = value !== undefined && value !== '' ? Number(value) : 0;

  const handleIncrement = (e) => {
    e.preventDefault();
    const nextVal = Math.min(numericValue + step, max);
    if (onChange) onChange(nextVal);
  };

  const handleDecrement = (e) => {
    e.preventDefault();
    const nextVal = Math.max(numericValue - step, min);
    if (onChange) onChange(nextVal);
  };

  // If the user types directly into the input, we use your required parseValue function
  const handleInputChange = (e) => {
    const rawString = e.target.value;
    const parsed = parseValue ? parseValue(rawString) : Number(rawString);
    if (!isNaN(parsed) && onChange) {
      onChange(parsed);
    }
  };

  // Apply your required formatValue function for display
  const displayValue = formatValue && value !== undefined && value !== '' 
    ? formatValue(value) 
    : value;

  return (
    /* We use a wrapper div to hold the buttons and input together (replacing the 'mobile' prop logic) */
    <div className="form-incremental-stepper-wrapper" {...cleanProps}>
      <button 
        type="button" 
        className="stepper-btn stepper-btn--decrement" 
        onClick={handleDecrement} 
        disabled={disabled || numericValue <= min}
      >
        -
      </button>

      <input
        type="text"
        className="form-incremental-stepper" // Kept your original class name on the input
        value={displayValue}
        onChange={handleInputChange}
        disabled={disabled}
        size={4}
      />

      <button 
        type="button" 
        className="stepper-btn stepper-btn--increment" 
        onClick={handleIncrement} 
        disabled={disabled || numericValue >= max}
      >
        +
      </button>
    </div>
  );
}

WrappedIncrementalFormStepper.propTypes = {
  formatValue: PropTypes.func.isRequired,
  parseValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired
};

export default WrappedIncrementalFormStepper;
